import axios from "axios";
import api from "../local/axios/api";
import * as apipath from "../local/config/api_paths";
// Login user
export const loginUser = async (email, password) => {
  try {
    const response = await api.post("/auth/login", { email, password });
    const { token } = response.data;
    localStorage.setItem("token", token); // Store token in local storage
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Register user
export const registerHost = async (userData) => {
  try {
    const response = await api.post(apipath.hostresgister, userData);
    return response?.data;
  } catch (error) {
    console.log("registerHost userService error", error.response.data);
    return error?.response?.data;
  }
};

// Fetch user profile (requires authentication)
export const registerUser = async (userData) => {
  try {
    const response = await api.post(apipath.userRegister, userData);
    return response?.data;
  } catch (error) {
    console.log("registerUser userService error", error?.response?.data);
    return error?.response?.data;
  }
};

export const resendOtp = async (resendOtpData) => {
  try {
    const response = await api.post(apipath.ResendOtp, resendOtpData);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const verifyOtp = async (OtpData) => {
  try {
    const response = await api.post(apipath?.VerifyOtp, OtpData);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const myProperties = async (searchValue, page, limit) => {
  try {
    const response = await api.get(
      `${apipath?.myProperties}?search=${searchValue}&page=${page}&limit=${limit}`
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const EnableDisablePropertys = async (data) => {
  try {
    const response = await api.post(
      `${apipath?.enableDisableProperty}`, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getDashboardData = async (data) => {
  try {
    // console.log('\n========== FRONTEND getDashboardData DEBUG ==========');
    // console.log('Request Data:', JSON.stringify(data, null, 2));

    const response = await api.get(apipath.dashboard, { params: data });

    // console.log('\n--- API RESPONSE ---');
    // console.log('Response Status:', response?.status);
    // console.log('Response Data:', JSON.stringify(response?.data, null, 2));
    // console.log('Properties Count:', response?.data?.result?.properties?.length || 0);
    // console.log('Property Type Counts:', response?.data?.result?.propertyTypeCounts);
    // console.log('========== FRONTEND getDashboardData END ==========\n');

    return response?.data;
  } catch (error) {
    console.error('\n========== FRONTEND getDashboardData ERROR ==========');
    console.error('Error:', error);
    console.error('Error Response:', error?.response?.data);
    console.error('========== ERROR END ==========\n');
    return error?.response?.data;
  }
};

export const updateProfile = async (data) => {
  try {
    const response = await api.post(apipath.updateProfile, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getUserDetail = async (data) => {
  try {
    const response = await api.get(apipath.userDetail, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const changePassword = async (data) => {
  try {
    const response = await api.post(apipath.updatepasword, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getPropertiesDiscountvalues = async (data) => {
  try {
    const response = await api.post(apipath.getPropertiesDiscount, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addDiscount = async (data) => {
  try {
    const response = await api.post(apipath.addDiscount, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getBlockedDates = async (id) => {
  try {
    const response = await api.get(
      `${apipath?.getBlockedDates}?propertyId=${id}`
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const blockDate = async (data) => {
  try {
    const response = await api.post(apipath.blockDate, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const forgotPasswordOTP = async (data) => {
  try {
    const response = await api.post(apipath.forgotpassword, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const verifyForgotPassword = async (data) => {
  try {
    const response = await api.post(apipath.verifyForgotPassword, data);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const Loginuser = async (data) => {
  try {
    const response = await api.post(apipath.login, data);

    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addWishlist = async (data) => {
  try {
    const response = await api.post(apipath.addWishlist, data);

    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const UserWishlist = async (page) => {
  try {
    const response = await api.get(
      `${apipath?.UserWishlist}?page=${page}&limit=12`
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const checkAvailabilyAndGetPrice = async (data) => {
  try {
    const response = await api.post(apipath.checkAvailabilyAndGetPrice, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const BookProperty = async (data) => {
  try {
    const response = await api.post(apipath.reserveProperty, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const MyBooking = async (data) => {
  try {
    const response = await api.post(apipath.myBookings, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const hostBookings = async (data, page) => {
  try {
    const response = await api.post(`${apipath.hostBookings}?page=${page}`, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const cancelBookingUser = async (data) => {
  try {
    const response = await api.post(apipath.cancelBooking, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const acceptRejectBookingHost = async (data) => {
  try {
    const response = await api.post(apipath.acceptRejectBooking, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addReviewForProperty = async (data) => {
  try {
    const response = await api.post(apipath.addReviewForProperty, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const GetPropertyReviews = async (propertyId, page) => {
  try {
    const response = await api.get(
      `${apipath?.PropertyReviews}?page=${page}&propertyId=${propertyId}`
    );
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addProfilePicture = async (data) => {
  try {
    // console.log("========== addProfilePicture API Call ==========");
    const response = await api.post(apipath.addProfilePicture, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    // console.log("Raw API Response:", response);
    // console.log("Response Data:", response?.data);
    // console.log("Response Data URL:", response?.data?.url);
    // console.log("Response Data Status:", response?.data?.status);
    return response?.data;
  } catch (error) {
    console.error("addProfilePicture API Error:", error);
    console.error("Error Response:", error?.response?.data);
    return error?.response?.data;
  }
};

export const Myreferrals = async (data) => {
  try {
    const response = await api.post(apipath.Myreferrals, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const googleLogin = async (data) => {
  try {
    const response = await api.post(apipath.googleLogin, data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};


export const viewProperty = async (com, req = null) => {
  try {
    const ipResponse = await axios.get('https://api.ipify.org?format=json');
    const ipAddress = ipResponse?.data?.ip || '223.178.210.198';
    const country = ipResponse?.data?.country || 'unknown';

    // console.log('IP Address:', ipAddress);
    // console.log('Country:', country);

    const data = {
      ip_address: ipAddress,
      country: country,
      property_id: com.propertyId,
    };

    const viewResponse = await api.post(apipath.addPropertyView, data);
    return viewResponse?.data;
  } catch (error) {
    console.log('Error in GET or POST request:', error);
    return error?.response?.data;
  }
};
